<template>
  <v-dialog v-model="phoneNumberDialog" width="400" persistent>
    <v-card>
      <v-card-title :style="`color: ${$vuetify.theme.themes.light.primary}`">
        {{ $translate('PHONE_NO_RECOGNITION') }}

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="pl-2" small v-bind="attrs" v-on="on">
              mdi-help-circle-outline
            </v-icon>
          </template>
          <span>{{ $translate('PHONE_WHY') }}</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text>
        {{ $translate('PHONE_NO_RECOGNITION_DESC') }}
        <v-text-field
          class="mt-4"
          @input="updatedPhoneNumber"
          dense
          :label="$translate('PHONE_NR')"
          v-model="userPhoneNumber"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" @click="closeDialog">
          {{ $translate('NO') }}
        </v-btn>
        <v-btn
          color="primary"
          class="primary-font-color"
          @click="continueBooking"
        >
          {{ $translate('YES') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Booking_Phone_Dialog',
  props: {
    phoneNumberDialog: {
      type: Boolean,
      default: false,
    },
    value: String,
  },
  watch: {
    value() {
      this.userPhoneNumber = this.value;
    },
  },
  computed: {},
  data() {
    return {
      userPhoneNumber: this.value,
    };
  },
  methods: {
    updatedPhoneNumber() {
      this.$emit('input', this.userPhoneNumber);
    },
    continueBooking() {
      this.$emit('continue');
    },
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped></style>
